import { render, staticRenderFns } from "./construcredix.vue?vue&type=template&id=a123da14&"
import script from "./construcredix.vue?vue&type=script&lang=js&"
export * from "./construcredix.vue?vue&type=script&lang=js&"
import style0 from "./construcredix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports